import { getCookie, getImage } from '@/utils'
import Vue from 'vue'
import { h } from 'vue'
import ElImageViewer from 'element-ui/packages/image/src/image-viewer.vue'
Vue.component('el-image-viewer', ElImageViewer)
export default function (conf, defaultValue) {
    const { accept, __config__: config, limit, action } = conf
    const { option: { config: staticConf } } = this.$attrs
    const newFileListValue = defaultValue && Array.isArray(defaultValue) && defaultValue.map(item => {
        return {
            name: item.fileName || '无文件名',
            url: item.url
        }
    })
    return {
        attrs: {
            headers: { ['Authorization']: staticConf.VUE_APP_REQUEST_HEADER_PREFIX + getCookie('Authorization') },
            accept: accept && typeof accept === "object" ? accept.join() : accept,
            // 上传回调事件
            'on-success': (response, file) => {
                if (response && response.code === 200) {
                    const newValue = defaultValue || []
                    const url = response.data.downloadUrl
                    let thumbnail_url = ''
                    const { name } = file
                    // 使用正则表达式匹配文件后缀
                    const regex = /(?:\.([^.]+))?$/
                    // 返回捕获组中的文件后缀名，如果没有后缀名，则返回空字符串
                    const type = regex.exec(name)[1] || ""
                    const typeMap = {
                        pdf: "https://tse3-mm.cn.bing.net/th/id/OIP-C.S5q0RORYqnZMWJvhof7roAAAAA?w=156&h=158&c=7&r=0&o=5&dpr=2&pid=1.7",
                        xlsx: "https://tse3-mm.cn.bing.net/th/id/OIP-C.TcwSOOjjlCsaojeAxE6R-QHaHa?w=194&h=194&c=7&r=0&o=5&dpr=2&pid=1.7",
                    }
                    const val = typeMap[type]
                    if (val) thumbnail_url = val
                    newValue.push({
                        fileName: name,
                        thumbnail_url,
                        url: url,
                    })
                    // this.$set(this.conf.__config__, "defaultValue", newValue)
                    this.$emit('input', newValue)
                }
            },
            'on-remove': (file, fileList) => {
                this.$emit('input', fileList.map(item => {
                    return {
                        fileName: item.name,
                        url: item.url
                    }
                }))
            },
            'list-type': conf["list-type"] ? conf["list-type"] : "picture",
            'file-list': newFileListValue,
            'on-exceed': () => {
                this.$message.error(`最多上传${limit}个文件`)
                return false
            },
            'before-upload': file => {
                const { type } = file
                const _type = type.split("/")
                const _accept = accept && typeof accept === "object" ? accept.join() : accept
                if (_accept && _accept.includes("image/*") && _type[0] !== "image") {
                    this.$message.error("请上传图片！")
                    return false
                }
                let sizeUnitNum = 1
                // 文件大小判断
                switch (config.sizeUnit) {
                    case "KB":
                        sizeUnitNum = 1024;
                        break;
                    case "MB":
                        sizeUnitNum = 1024 * 1024;
                        break;
                    case "GB":
                        sizeUnitNum = 1024 * 1024 * 1024;
                        break;
                }
                const totalSize = config.fileSize * sizeUnitNum
                if (file.size > totalSize) {
                    this.$message.error(
                        `上传文件大小不能超过${config.fileSize}${config.sizeUnit}`
                    );
                    return false
                }
            },
            'on-preview': file => {
                const { name, url } = file
                let _url
                defaultValue.forEach((item) => {
                    if (item.fileName === name) _url = item._url
                })
                const regImg = /\.(jpg|png|gif|bmp|jpeg)$/
                const flag = _url ? regImg.test(name || _url) : regImg.test(name || url)
                if (flag) {
                    const imgPreview = Vue.extend({
                        data() {
                            return {
                                showViewer: true
                            }
                        },
                        render(h) {
                            return this.showViewer ? h('el-image-viewer', { props: { onClose: () => this.showViewer = false, urlList: [getImage(url)] } }, undefined) : null
                        }
                    })
                    const initInstance = () => {
                        new imgPreview({
                            el: document.createElement('div')
                        });
                    }
                    initInstance()
                }
            },
            'action': action
        }
    }
}